import type React from 'react';

import { ModuleSeparator } from '#src/app/pages/starterDashboardV2/shared/components';
import { useDynamicModules } from '#src/app/pages/starterDashboardV2/shared/contexts';

import { PromoteYourPetition } from './components/PromoteYourPetition';
import { ShareVisual } from './components/ShareVisual';
import { ShareYourPetition } from './components/ShareYourPetition';
import { ShareYourPetitionOffline } from './components/ShareYourPetitionOffline';
import { useGrowPetition } from './hooks/useGrowPetition';

export const GrowPetition: React.FC = () => {
	const { data } = useGrowPetition();
	const { isDynamicModuleLoaded } = useDynamicModules();

	return (
		<section role="group" aria-labelledby="grow-petition-title">
			<ShareVisual />
			{isDynamicModuleLoaded('ShareVisual') && <ModuleSeparator />}
			<div className="flex flex-col [@media(min-width:1204px)]:flex-row">
				<div className="min-w-0 flex-1">
					<ShareYourPetition />
				</div>
				<div className="flex min-w-px">
					<ModuleSeparator className="block [@media(min-width:1204px)]:hidden" />
					<ModuleSeparator orientation="vertical" className="hidden [@media(min-width:1204px)]:block" />
				</div>
				<div className="min-w-0 flex-1">
					<ShareYourPetitionOffline />
				</div>
			</div>
			{data.shouldShowPromoteYourPetition && (
				<>
					<ModuleSeparator />
					<PromoteYourPetition />
				</>
			)}
		</section>
	);
};
